import { ModalWindow } from '@cian/ui-kit';
import { forwardRef } from 'react';

import styles from './MapModal.css';

interface IMapModalProps {
  isOpen: boolean;
  onClose(): void;
}

const MapModal = forwardRef<HTMLDivElement, IMapModalProps>(({ isOpen, onClose }, ref) => {
  return (
    <ModalWindow
      content={<div className={styles['map']} ref={ref} />}
      escape
      fixed={false}
      outside
      size="M"
      open={isOpen}
      onClose={onClose}
    />
  );
});

MapModal.displayName = 'MapModal';

export { MapModal };
